function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "4.5179mm",
    height: "4.2968mm",
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M5 9l8 0 0 -2c0,-4 3,-7 7,-7l0 0c4,0 7,3 7,7l0 2 7 0c3,0 6,3 6,6l0 7 2 0c4,0 7,3 7,7l0 0c0,4 -3,7 -7,7l-2 0 0 8c0,3 -3,5 -6,5l-9 0 0 -4c0,-2 -3,-4 -5,-4l0 0c-3,0 -5,2 -5,4l0 4 -10 0c-3,0 -5,-2 -5,-5l0 -10 4 0c3,0 5,-2 5,-5l0 0c0,-2 -2,-4 -5,-4l-4 0 0 -10c0,-3 2,-6 5,-6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.9d1f6db45c040f4babe8f5c751d524da.svg";
export { ForwardRef as ReactComponent };